// extracted by mini-css-extract-plugin
export var text = "_ax-0";